import PropTypes from 'prop-types'

const IconListItem = ({baseClass, icon: Icon, itemValue, listItem}) => {
  return (
    <div className={`${baseClass}-listIconItemWrapper`}>
      <Icon size="medium" />
      <div className={`${baseClass}-listIconTitleWrapper`}>
        <p className={`${baseClass}-listItemValue`}>{listItem}</p>
        <p className={`${baseClass}-listItemValue ${baseClass}-listItemValue--blackBold`}>{itemValue}</p>
      </div>
    </div>
  )
}

IconListItem.displayName = 'IconListItem'
IconListItem.propTypes = {
  baseClass: PropTypes.string.isRequired,
  icon: PropTypes.func.isRequired,
  itemValue: PropTypes.string.isRequired,
  listItem: PropTypes.string.isRequired
}

export default IconListItem
